import { SESSION_DURATION_MS, SESSION_ID_LENGTH } from './constants';
export const isSessionState = (maybeSessionState) => typeof maybeSessionState === 'object' &&
    maybeSessionState !== null &&
    'id' in maybeSessionState &&
    typeof maybeSessionState['id'] === 'string' &&
    maybeSessionState.id.length === SESSION_ID_LENGTH &&
    'startTime' in maybeSessionState &&
    typeof maybeSessionState['startTime'] === 'number';
export const isSessionDurationExceeded = (sessionState) => {
    const now = Date.now();
    return sessionState.startTime > now || now > sessionState.startTime + SESSION_DURATION_MS;
};
export const isSessionInactivityTimeoutReached = (sessionState) => {
    if (sessionState.expiresAt === undefined) {
        return false;
    }
    const now = Date.now();
    return now > sessionState.expiresAt;
};
//# sourceMappingURL=utils.js.map